import { ContactInfoTabMessages } from "@/messages/campaigns/contact-info-tab.messages";

export const CONTACTS_TABLE_COLUMNS = (messages: ContactInfoTabMessages) => {
  return [
    messages.contactNameLabel,
    messages.contactEmailLabel,
    messages.contactPhoneLabel,
    messages.contactCityLabel,
    messages.contactStateLabel,
  ];
};
